import { createRoot } from 'react-dom/client';
import { registerRemotes } from '@module-federation/runtime';
import { config, net } from 'zf-web-infra';
import { CONFIG, MF_REMOTES } from 'config';
import { i18n } from 'zf-web-components';
import { plugin } from 'zf-web-components/widgets';
import { customize } from '@customize';
import { App } from '../features/app';
import { router } from '../features/app/router';
import { meta, day, fetcher } from '../services';
import { RootStore } from '../stores';
import { translation } from '../translation';
import type { Remote } from '@module-federation/runtime/types';

class Main {

  async init(): Promise<void> {
    const container = document.querySelector('#root');
    if (container == null) {
      return;
    }

    const store = new RootStore();

    config.init(CONFIG);
    net.init(store.local);
    i18n.init(store.local, translation);
    meta.init(store.local);
    customize.init(store.local); // 定制初始化
    plugin.register({ kind: 'fetcher', fetcher });
    day.init(store.local);

    this.initFederation();
    await store.refreshUser();

    createRoot(container).render((<App store={store} />));
  }

  /**
   * 初始化联邦模块
   */
  private initFederation(): void {
    const remotes: Remote[] = [];
    for (const remote of MF_REMOTES) {
      if (remote.enable) {
        remotes.push({ name: remote.name, entry: remote.entry });
      }
    }
    registerRemotes(remotes);
  }

}

new Main().init();
